import React, { useState } from "react";
import classes from "./Newappointment.module.css";
import { 
    FaTimes, 
    FaUser, 
    FaCalendarAlt, 
    FaClock, 
    FaCheckCircle, 
    FaChevronDown,
    FaFileAlt,
    FaCheck
} from "react-icons/fa";

const Newappointment = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        patient: "",
        contact: "",
        email: "",
        department: "Cardiology",
        doctor: "Dr. James Wilson",
        visitType: "OPD - Outpatient",
        date: "2024-05-21",
        time: "10:30 AM",
        duration: "30 Minutes",
        location: "OPD - Room 2",
        priority: "Normal",
        apptType: "New Consultation",
        reason: "",
        notes: "",
        reminder: "SMS & Email",
        advanceNotice: "1 Day Before",
        sendConfirmation: true
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    if (!isOpen) return null;

    return (
        <div className={classes.modalOverlay}>
            <div className={classes.modalContainer}>
                
                {/* HEADER */}
                <div className={classes.modalHeader}>
                    <div className={classes.headerLeft}>
                        <div className={classes.headerIcon}>
                            <FaFileAlt />
                        </div>
                        <div>
                            <h2>New Appointment</h2>
                            <p>Schedule a new appointment for a patient</p>
                        </div>
                    </div>
                    <button className={classes.closeBtn} onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className={classes.modalBody}>
                    
                    {/* SECTION 1: PATIENT INFORMATION */}
                    <div className={classes.formSection}>
                        <h3 className={classes.sectionTitle}>Patient Information</h3>
                        <div className={classes.grid2Col}>
                            <div className={classes.formGroup}>
                                <label>Patient <span className={classes.required}>*</span></label>
                                <div className={classes.searchSelect}>
                                    <input 
                                        type="text" 
                                        placeholder="Search patient by name or ID..."
                                        className={classes.searchInput}
                                    />
                                    <span className={classes.dropIcon}><FaChevronDown /></span>
                                </div>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Contact Number</label>
                                <input 
                                    type="text" 
                                    name="contact"
                                    value={formData.contact}
                                    onChange={handleChange}
                                    placeholder="+1 987 654 3210"
                                    className={classes.formInput}
                                />
                            </div>
                        </div>

                        {/* Selected Patient Card (Appears after search) */}
                        <div className={classes.patientCard}>
                            <div className={classes.patientAvatar}>
                                <FaUser />
                            </div>
                            <div className={classes.patientInfo}>
                                <h4>John Doe</h4>
                                <p>OPD - 12345 &nbsp;|&nbsp; 34 Y / Male</p>
                            </div>
                        </div>

                        <div className={classes.grid2Col} style={{marginTop: '16px'}}>
                            <div className={classes.formGroup}>
                                <label>Email (Optional)</label>
                                <input 
                                    type="email" 
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="johndoe@email.com"
                                    className={classes.formInput}
                                />
                            </div>
                        </div>
                    </div>

                    {/* SECTION 2: APPOINTMENT DETAILS */}
                    <div className={classes.formSection}>
                        <h3 className={classes.sectionTitle}>Appointment Details</h3>
                        <div className={classes.grid3Col}>
                            <div className={classes.formGroup}>
                                <label>Department <span className={classes.required}>*</span></label>
                                <select name="department" value={formData.department} onChange={handleChange} className={classes.formSelect}>
                                    <option>Cardiology</option>
                                    <option>General Medicine</option>
                                    <option>Orthopedics</option>
                                    <option>Pediatrics</option>
                                </select>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Doctor <span className={classes.required}>*</span></label>
                                <select name="doctor" value={formData.doctor} onChange={handleChange} className={classes.formSelect}>
                                    <option>Dr. James Wilson</option>
                                    <option>Dr. Sarah Ahmed</option>
                                    <option>Dr. Michael Lee</option>
                                    <option>Dr. Priya Sharma</option>
                                </select>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Visit Type <span className={classes.required}>*</span></label>
                                <select name="visitType" value={formData.visitType} onChange={handleChange} className={classes.formSelect}>
                                    <option>OPD - Outpatient</option>
                                    <option>IPD - Inpatient</option>
                                    <option>Emergency</option>
                                </select>
                            </div>
                        </div>

                        <div className={classes.grid3Col}>
                            <div className={classes.formGroup}>
                                <label>Appointment Date <span className={classes.required}>*</span></label>
                                <div className={classes.inputWithIcon}>
                                    <FaCalendarAlt className={classes.inputIcon} />
                                    <input type="date" name="date" value={formData.date} onChange={handleChange} className={classes.formInput} />
                                </div>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Appointment Time <span className={classes.required}>*</span></label>
                                <div className={classes.inputWithIcon}>
                                    <FaClock className={classes.inputIcon} />
                                    <input type="time" name="time" value={formData.time} onChange={handleChange} className={classes.formInput} />
                                </div>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Duration</label>
                                <select name="duration" value={formData.duration} onChange={handleChange} className={classes.formSelect}>
                                    <option>15 Minutes</option>
                                    <option>30 Minutes</option>
                                    <option>45 Minutes</option>
                                    <option>60 Minutes</option>
                                </select>
                            </div>
                        </div>

                        <div className={classes.grid3Col}>
                            <div className={classes.formGroup}>
                                <label>Location / Room (Optional)</label>
                                <select name="location" value={formData.location} onChange={handleChange} className={classes.formSelect}>
                                    <option>OPD - Room 2</option>
                                    <option>OPD - Room 4</option>
                                    <option>Ward A</option>
                                    <option>ICU</option>
                                </select>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Priority</label>
                                <select name="priority" value={formData.priority} onChange={handleChange} className={classes.formSelect}>
                                    <option>Normal</option>
                                    <option>High</option>
                                    <option>Emergency</option>
                                </select>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Appointment Type</label>
                                <select name="apptType" value={formData.apptType} onChange={handleChange} className={classes.formSelect}>
                                    <option>New Consultation</option>
                                    <option>Follow-up</option>
                                    <option>Check-up</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* SECTION 3: REASON & NOTES */}
                    <div className={classes.formSection}>
                        <h3 className={classes.sectionTitle}>Reason & Notes</h3>
                        <div className={classes.grid2Col}>
                            <div className={classes.formGroup}>
                                <label>Reason for Visit <span className={classes.required}>*</span></label>
                                <textarea 
                                    name="reason" 
                                    value={formData.reason}
                                    onChange={handleChange}
                                    className={classes.formTextarea} 
                                    rows="4"
                                    placeholder="Chest pain and discomfort"
                                ></textarea>
                                <div className={classes.charCount}>25 / 500</div>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Notes (Optional)</label>
                                <textarea 
                                    name="notes" 
                                    value={formData.notes}
                                    onChange={handleChange}
                                    className={classes.formTextarea} 
                                    rows="4"
                                    placeholder="Add any additional notes..."
                                ></textarea>
                                <div className={classes.charCount}>0 / 500</div>
                            </div>
                        </div>
                    </div>

                    {/* SECTION 4: REMINDERS & PREFERENCES */}
                    <div className={classes.formSection}>
                        <h3 className={classes.sectionTitle}>Reminders & Preferences</h3>
                        <div className={classes.grid2Col}>
                            <div className={classes.formGroup}>
                                <label>Reminder to Patient</label>
                                <select name="reminder" value={formData.reminder} onChange={handleChange} className={classes.formSelect}>
                                    <option>SMS & Email</option>
                                    <option>SMS Only</option>
                                    <option>Email Only</option>
                                    <option>None</option>
                                </select>
                            </div>
                            <div className={classes.formGroup}>
                                <label>Advance Notice</label>
                                <select name="advanceNotice" value={formData.advanceNotice} onChange={handleChange} className={classes.formSelect}>
                                    <option>1 Day Before</option>
                                    <option>2 Days Before</option>
                                    <option>1 Week Before</option>
                                </select>
                            </div>
                        </div>
                        
                        <div className={classes.checkboxGroup}>
                            <label className={classes.checkboxLabel}>
                                <input 
                                    type="checkbox" 
                                    name="sendConfirmation" 
                                    checked={formData.sendConfirmation} 
                                    onChange={handleChange}
                                />
                                <span className={classes.customCheckbox}></span>
                                Send appointment confirmation to patient
                            </label>
                        </div>
                    </div>

                </div>

                {/* FOOTER */}
                <div className={classes.modalFooter}>
                    <button className={classes.cancelBtn} onClick={onClose}>Cancel</button>
                    <button className={classes.createBtn} onClick={() => { alert("Appointment Created!"); onClose(); }}>
                        <FaCheckCircle /> Create Appointment
                    </button>
                </div>

            </div>
        </div>
    );
};

export default Newappointment;